import React, { useContext } from "react";
import PropTypes from "prop-types";
import ExposureContainer from "../../../../document/edit/exposure/components/ExposureContainer";
import FolderCommentsCardContainer from "features/folder/edit/comments/components/FolderCommentsCardContainer";
import { RightsContext } from "providers/RightsContext";

const FolderExposureContainer = ({ documentId, siteId }) => {
  const { folderExposureRead } = useContext(RightsContext);
  return (
    <>
      {folderExposureRead && <ExposureContainer documentId={documentId} siteId={siteId} />}
      <FolderCommentsCardContainer documentId={documentId} siteId={siteId} />
    </>
  );
};

FolderExposureContainer.propTypes = {
  documentId: PropTypes.number,
  siteId: PropTypes.number
};

export default FolderExposureContainer;
